<template>
  <div class="mt-4 w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-4">
    <div class="bg-white shadow rounded-lg p-4 sm:p-6 xl:p-8 ">
      <div class="flex items-center justify-between">
        <div class="flex-shrink-0">
          <span class="text-2xl sm:text-3xl leading-none font-bold text-gray-900">{{report.major.applicants}}</span>
          <h3 class="text-base font-normal text-gray-500">Applicants</h3>
        </div>
        <icon name="download" class="block w-3 h-3 fill-gray-400 cursor-pointer" @click="exportDataDetails('applicants')"/>
      </div>
    </div>
    <div class="bg-white shadow rounded-lg p-4 sm:p-6 xl:p-8 ">
      <div class="flex items-center justify-between">
        <div class="flex-shrink-0">
          <span class="text-2xl sm:text-3xl leading-none font-bold text-gray-900">{{report.major.interventions}}</span>
          <h3 class="text-base font-normal text-gray-500">Interventions</h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Icon from '@/Shared/Icon'
export default {
  components:{Icon},
  props: {
    report: {
      type: Object,
    },
  },
  methods:{
    exportDataDetails(item){
      this.$emit('exportDataDetails', item)
    },
  },
}
</script>
